import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import Button from "@result/result-ui-components/src/components/Button";
import ApiClient from "../../../state/api/ApiClient";
import {useKeycloak} from "@react-keycloak/web";

const DeleteUserPage = () => {
  const { t } = useTranslation();
  const [isConfirmDeletion, setIsConfirmDeletion] = useState(false);
  const [isUserDataDeleted, setIsUserDataDeleted] = useState(false);
  const [isDeleteUserError, setIsDeleteUserError] = useState(false);

  const keycloakInstance = useKeycloak();

  const deleteUser = () => {
    ApiClient.delete("/api/profile/delete").then(r => {
      setIsUserDataDeleted(true);
      setIsDeleteUserError(false);
      setTimeout(() => {
        keycloakInstance.keycloak.logout();
      }, 3000)
    }).catch((e) => {
      setIsDeleteUserError(true);
    });
  }

  if(isUserDataDeleted) {
    return (
      <div className="main-section pt-4">
        {t('delete_user_data.delete_success')}
      </div>
    )
  }

  return (
    <div className="main-section pt-4">
      <div>
        <p className="is-size-2 mb-2">
        {t('delete_user_data.title')}
        </p>
      </div>
      {t('delete_user_data.content')}
      <div className="mt-2">
        {!isConfirmDeletion &&
          <Button
            label={t('delete_user_data.delete_user_data')}
            onClick={() => setIsConfirmDeletion(true)}
          />
        }
        {isConfirmDeletion &&
          <div>
            <Button
              label={t('delete_user_data.cancel')}
              onClick={() => {setIsConfirmDeletion(false)}}
              className="mr-2"
            />
            <Button
              label={t('delete_user_data.confirm_delete_user_data')}
              onClick={() => {deleteUser()}}
            />
          </div>
        }
        {isDeleteUserError && <div style={{color: "red"}}>{t('delete_user_data.delete_error')}</div>}
      </div>
    </div>
    )
}

export default DeleteUserPage;